import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
export { getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBJxM1edlClnhLV1_nhVO7MkIc_37nhCq8",
  authDomain: "crush-me-6d154.firebaseapp.com",
  projectId: "crush-me-6d154",
  storageBucket: "crush-me-6d154.appspot.com",
  messagingSenderId: "927540468542",
  appId: "1:927540468542:web:078bad1fcc61fdc2626a6f",
  measurementId: "G-CTL4HS2BTP"
};

const app = initializeApp(firebaseConfig);

let messaging = null;
try {
  // Capacitor Android : serviceWorker peut être absent mais Notification présent
  // On tente l'initialisation dans tous les cas navigateur/webview
  if (typeof window !== "undefined") {
    messaging = getMessaging(app);
    console.log("✅ [FCM] Firebase Messaging initialisé");
  }
} catch (err) {
  console.warn("⚠️ Firebase Messaging non disponible :", err.message);
}

export { messaging };
export const getMessagingInstance = () => messaging;
export const requestPermissionAndGetToken = async () => ({ success: false, message: "À implémenter" });
